﻿<script setup>
import {defineModel, computed, defineProps} from "vue";

import rules from "@/utils/validationRules.js";
import ReferralFormLabel from "@/components/ReferralFormLabel.vue";

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  showDetails: {
    type: Boolean,
    default: false,
  } 
})

const modelChk = defineModel()
const modelDetails = defineModel("details")

const rulesToUse = computed(() => props.required ? [rules.required] : []);


</script>

<template>
  <v-row>
    <v-col cols="12">
      <ReferralFormLabel :required="required">{{ label }}</ReferralFormLabel>
      <v-radio-group v-model="modelChk" inline hide-details class="text-h6 mt-2" color="primary" :required="required" :rules="rulesToUse">
        <v-radio label="Yes" value="yes" class="pr-5"></v-radio>
        <v-radio label="No" value="no" class="pr-5"></v-radio>
        <v-radio label="Unsure" value="unsure" class="pr-5"></v-radio>
      </v-radio-group>
    </v-col>
    <v-col cols="12" v-if="showDetails">
      <v-textarea v-model="modelDetails" required placeholder="Please provide details" :rules="[rules.required]"/>
    </v-col>
  </v-row>
</template>
